import { useFragment } from '@apollo/client';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import clsx from 'clsx';
import { S3Avatar } from '../s3/user/s3-avatar';
import { UserBadgeFragment } from './user-badge-fragment';
import {
  userAvatar,
  userContainer,
  userHandle,
  userHandleInversed,
  userInfo,
  userName,
  userNameInversed,
  userNameUnderline,
} from './user-badge.css';

export const UserBadge = ({
  id,
  size,
  underlineTitleOnHover = true,
  inversed,
  className,
}: {
  id: string;
  size?: 'medium' | 'small' | 'xm';
  underlineTitleOnHover?: boolean;
  inversed?: boolean;
  className?: string;
}) => {
  const { data, complete } = useFragment({
    fragment: UserBadgeFragment,
    fragmentName: 'UserBadgeFragment',
    from: {
      __typename: 'User',
      id,
    },
  });
  const isTablet = useIsTablet();

  return complete ? (
    <div className={clsx(userContainer, className)}>
      <S3Avatar
        className={userAvatar}
        size={size || (isTablet ? 'medium' : 'small')}
        s3Key={data.avatar?.key}
        userId={data.id}
      />
      <div className={userInfo}>
        <span
          className={clsx(
            userName,
            underlineTitleOnHover && userNameUnderline,
            inversed && userNameInversed,
          )}
        >
          {data.fullName}
        </span>
        <span
          className={clsx(userHandle, inversed && userHandleInversed)}
          data-testid={'user-badge-username'}
        >{`@${data.username}`}</span>
      </div>
    </div>
  ) : null;
};
